import React from 'react'
import * as facemesh from '@tensorflow-models/facemesh'
import FPSStats from 'react-fps-stats'
import{sequenceTest}from './sequence.js'
import {BsChevronLeft} from 'react-icons/bs'
import colors from './colors.json'
import Loader from './loader'
export default class LiveTryOn extends React.Component{
	constructor(props){
		super(props)
		this.state={
			error:false ,
			selected:'None',
			loaded:true,
			message:"none"
		}
		this.canvasRef=React.createRef()
		this.videoRef=React.createRef()
		this.getCameraAccess = this.getCameraAccess.bind(this)
		this.loadModel=this.loadModel.bind(this)
		this.changeColor=this.changeColor.bind(this)
		this.renderPredictions=this.renderPredictions.bind(this)
		this.backBtnClick=this.backBtnClick.bind(this)
		if(window.innerWidth>760){
			this.canvasHeight=500
			this.canvasWidth=500
		} 
		else{
			this.canvasWidth=window.innerWidth
			this.canvasHeight=window.innerWidth+50
		}
		this.colors=colors
	}
	backBtnClick(){ 
		cancelAnimationFrame(this.raf)
		this.props.close(true)
	}
	componentDidMount(){
		this.getCameraAccess()
	}
	async getCameraAccess(){
		navigator.mediaDevices.getUserMedia({
			video:{width:500,height:500,facingMode:'user'}
		})
		.then((stream)=>{
			this.videoRef.current.srcObject=stream
			this.loadModel()	
		})
		.catch((error)=>{ 
			if(typeof(error)==='object'){
				console.log('err',error)
				this.setState({
				error:true,
				message:error
			})
			}
		})
	}
	changeColor(val){
		this.setState({
			selected:val.rgba
		})
	}
	loadModel(){
		//console.log('inside load model')
		facemesh.load()
		.then((model)=>{
			this.model=model
			this.renderPredictions()	
		})
	}
	renderPredictions(){
		this.setState({
				loaded:false
			})
		let ctx=this.canvasRef.current.getContext('2d')
		ctx.strokeStyle='rgba(195, 12, 61, 0.9)'
		ctx.lineWidth=0.1
		this.model.estimateFaces(this.videoRef.current)
		.then((val)=>{
			let sequencePoints=[]
			this.canvasRef.current.getContext('2d').drawImage(this.videoRef.current,0,0,500,500)
			if(val.length !== 0){
				const scaledMesh = val[0].scaledMesh
				for(let x in sequenceTest){
					let point=scaledMesh[sequenceTest[x]]
					let arr={
						x:point[0],
						y:point[1]
					}
					sequencePoints.push(arr)
				}
				const region = new Path2D()
				region.moveTo(sequencePoints[0].x,scaledMesh[0].y)
			 	const draw=()=>{
			 	for(let i=1 ; i< sequencePoints.length;i++){
			 		region.lineTo(sequencePoints[i].x,sequencePoints[i].y)
			 	}
			 	region.closePath()
				ctx.stroke(region)
				ctx.fillStyle = this.state.selected
				if(this.state.selected!=='None'){
					ctx.fill(region,'nonzero')
				}
			 	}
		 		draw()
		 	}	
		})
		.catch((err)=>{
			console.log(err)
		})
		this.raf=requestAnimationFrame(this.renderPredictions) 
	}
	render(){
		return(
			<div> 
			 <video ref={this.videoRef} autoPlay className="video"></video>
			<div> 
				{this.state.error ? 
					<div className="tryon-container">
						<button className="back-btn" onClick={this.backBtnClick}><BsChevronLeft/></button>
						<div className="secondary-tryon-container ">
							<p className="err-mess">We need camera permissions. You can still use Try On a Model.</p> 
						</div>
					</div>
				:
				<div>
				{this.state.loaded ? <Loader/> :  
				<div>
					<div className="tryon-container">
						<button className="back-btn" onClick={this.backBtnClick}><BsChevronLeft/></button>
							<div className="secondary-tryon-container text-center">
								<canvas ref={this.canvasRef} height={this.canvasHeight} width={this.canvasWidth} className="canvas"></canvas>
								<div className="slider">
									{this.colors.map((val)=><button className="scroll-div" style={{backgroundColor:val.hex}} key={val.name} onClick={()=>this.changeColor(val)}>{val.name}</button>)}
								</div>

							</div>
						</div>
					</div>
				}
				</div>
				}
			</div>
		</div>
		)
	}
}





